module.exports = __webpack_public_path__ + "assets/661a2ecf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/movie2.jpg
// module id = 96
// module chunks = 0